// extracted by mini-css-extract-plugin
export default {"main":"glag_main__FlOP8","active":"glag_active__F0zQu","text":"glag_text__zcxNf","team":"glag_team__ccnGj"};